import React from 'react';
import BlockHeader from 'pages/components/blockHeader';
import SecondaryButton from 'shared/lib/components/controls/buttons/secondaryButton';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';
import { useTranslation } from 'react-i18next';

export default function ExplorerHeader({
  name,
  onSettings,
  onGoToUpload,
  isButtonsDisabled,
}: {
  name: string;
  onSettings?: () => void;
  onGoToUpload: () => void;
  isButtonsDisabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <BlockHeader
      text={name}
      buttonsNode={
        isButtonsDisabled ? null : (
          <ButtonsContainer variant="full">
            <SecondaryButton
              sx={{ visibility: onSettings ? 'visible' : 'hidden' }}
              onClick={onSettings}
            >
              {t('common.settings')}
            </SecondaryButton>
            <PrimaryButton onClick={onGoToUpload}>Добавить</PrimaryButton>
          </ButtonsContainer>
        )
      }
    ></BlockHeader>
  );
}
